var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              conteudo: _vm.conteudoModal,
              isVTN: false,
              isImagem: _vm.isImagem,
              tituloDocumento: _vm.tituloDocumento
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _vm.showModalVisualizarProcesso && _vm.informacoesSolicitacao
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.informacoesSolicitacao.idProcesso,
              protocolo: _vm.informacoesSolicitacao.numeroProtocolo,
              numeroProcesso: _vm.informacoesSolicitacao.numeroProcesso,
              tipo: _vm.informacoesSolicitacao.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e(),
      _vm.informacoesSolicitacao
        ? _c("div", { staticClass: "d-flex" }, [
            _c("p", { staticClass: "styleInfo" }, [
              _vm._v(
                "Informações do processo: " +
                  _vm._s(_vm.informacoesSolicitacao.numeroProcesso)
              )
            ]),
            _c(
              "div",
              {
                staticClass: "verde",
                on: {
                  click: function($event) {
                    _vm.showModalVisualizarProcesso = true
                  }
                }
              },
              [
                _c("font-awesome-icon", { attrs: { icon: "eye", size: "sm" } }),
                _c("span", [_vm._v("  Visualizar Processo")])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.informacoesSolicitacao
        ? _c(
            "el-card",
            [
              _c("app-divider", {
                staticClass: "margin-bottom",
                attrs: { label: "Solicitação de Informações do Processo" }
              }),
              _c(
                "el-row",
                {
                  staticClass: "margin-top cardSolicitacao",
                  attrs: { gutter: 30 }
                },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("p", [
                      _c("b", [_vm._v(" Setor: ")]),
                      _vm._v(
                        " " + _vm._s(_vm.informacoesSolicitacao.setorOrigem)
                      )
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("p", [
                      _c("b", [_vm._v(" Responsável: ")]),
                      _vm._v(
                        " " + _vm._s(_vm.informacoesSolicitacao.responsavel)
                      )
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("p", [
                      _c("b", [_vm._v(" Data de Vencimento: ")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.informacoesSolicitacao.dataVencimento || "  -"
                          )
                      )
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("p", [
                      _c("b", [_vm._v(" Assunto: ")]),
                      _vm._v(" " + _vm._s(_vm.informacoesSolicitacao.assunto))
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("p", [
                      _c("b", [_vm._v(" Data de Solicitação: ")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.informacoesSolicitacao.mensagemList[0]
                              .dataEnviada
                          )
                      )
                    ])
                  ])
                ],
                1
              ),
              _c("app-divider", {
                staticClass: "margin-bottom",
                attrs: { label: "Solicitação:" }
              }),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.informacoesSolicitacao.mensagemList[0].conteudo
                  )
                }
              }),
              _c("app-divider", {
                staticClass: "margin-bottom",
                attrs: { label: "Anexos:" }
              }),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.informacoesSolicitacao.mensagemList[0].anexoList,
                    "show-header": false
                  }
                },
                [
                  _c("el-table-column", { attrs: { prop: "nome" } }),
                  _c("el-table-column", {
                    attrs: { align: "right", width: "110" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "btn-actions",
                                  attrs: {
                                    effect: "dark",
                                    content: !_vm.isDocumentoParaVisualizacao(
                                      scope.row
                                    )
                                      ? "Não é possível exibir esse arquivo"
                                      : "Visualizar Documento",
                                    placement: "left"
                                  }
                                },
                                [
                                  scope.row &&
                                  (_vm.isEstadoMA || _vm.isEstadoAP)
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "button",
                                          attrs: {
                                            disabled: !_vm.isDocumentoParaVisualizacao(
                                              scope.row
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.abrirDocumento(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "eye", size: "lg" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "Baixar arquivo",
                                    placement: "left"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "button",
                                      on: {
                                        click: function($event) {
                                          return _vm.downloadAnexo(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "download", size: "lg" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      898613691
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesSolicitacao &&
      _vm.informacoesSolicitacao.status === "RESPONDIDA"
        ? _c(
            "el-card",
            [
              _c(
                "el-row",
                { staticClass: "margin-top", attrs: { gutter: 30 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("p", [
                      _c("b", [_vm._v(" Setor: ")]),
                      _vm._v(
                        " " + _vm._s(_vm.informacoesSolicitacao.setorRequerido)
                      )
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("p", [
                      _c("b", [_vm._v(" Data da Resposta: ")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.informacoesSolicitacao.mensagemList[1]
                              .dataEnviada
                          )
                      )
                    ])
                  ])
                ],
                1
              ),
              _c("app-divider", {
                staticClass: "margin-bottom",
                attrs: { label: "Solicitacao Acesso:" }
              }),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.informacoesSolicitacao.statusSolicitacaoAcesso
                  )
                }
              }),
              _c("app-divider", {
                staticClass: "margin-bottom",
                attrs: {
                  label: _vm.isSolicitacaoExterno
                    ? "Justificativa:"
                    : "Resposta:"
                }
              }),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.informacoesSolicitacao.mensagemList[1].conteudo
                  )
                }
              }),
              _c("app-divider", {
                staticClass: "margin-bottom",
                attrs: { label: "Anexos:" }
              }),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.informacoesSolicitacao.mensagemList[1].anexoList,
                    "show-header": false
                  }
                },
                [
                  _c("el-table-column", { attrs: { prop: "nome" } }),
                  _c("el-table-column", {
                    attrs: { align: "right", width: "110" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "btn-actions",
                                  attrs: {
                                    effect: "dark",
                                    content: !_vm.isDocumentoParaVisualizacao(
                                      scope.row
                                    )
                                      ? "Não é possível exibir esse arquivo"
                                      : "Visualizar Documento",
                                    placement: "left"
                                  }
                                },
                                [
                                  scope.row && _vm.isEstadoAP
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "button",
                                          attrs: {
                                            disabled: !_vm.isDocumentoParaVisualizacao(
                                              scope.row
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.abrirDocumento(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "eye", size: "lg" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "Baixar arquivo",
                                    placement: "left"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "button",
                                      on: {
                                        click: function($event) {
                                          return _vm.downloadAnexo(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "download", size: "lg" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2761049796
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "validation-observer",
        { ref: "validation", attrs: { tag: "form" } },
        [
          _vm.isSolicitacaoExterno &&
          _vm.informacoesSolicitacao.status === "PENDENTE"
            ? _c(
                "el-card",
                { staticClass: "margin-top" },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: !_vm.isSolicitacaoExterno ? "" : "required"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-divider", {
                                staticClass: "margin-bottom",
                                attrs: {
                                  label: "Autorizar a solicitação de acesso:",
                                  required: "required"
                                }
                              }),
                              _c(
                                "el-radio-group",
                                {
                                  staticClass: "aling-center input",
                                  class: { erro: errors.length },
                                  model: {
                                    value: _vm.permiteAcesso,
                                    callback: function($$v) {
                                      _vm.permiteAcesso = $$v
                                    },
                                    expression: "permiteAcesso"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("Autorizar")
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("Não autorizar")
                                  ])
                                ],
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      225644289
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.informacoesSolicitacao &&
          _vm.informacoesSolicitacao.status === "PENDENTE"
            ? _c(
                "el-card",
                { staticClass: "margin-top" },
                [
                  _c("app-divider", {
                    staticClass: "margin-bottom",
                    attrs: {
                      label: "Responder Solicitação",
                      required: _vm.isEstadoMA
                    }
                  }),
                  _c("validation-provider", {
                    attrs: {
                      rules: _vm.isSolicitacaoExterno ? "" : "required"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: {
                                  type: "textarea",
                                  rows: 5,
                                  placeholder: "Digite o texto..."
                                },
                                model: {
                                  value: _vm.respostaInformacao,
                                  callback: function($$v) {
                                    _vm.respostaInformacao = $$v
                                  },
                                  expression: "respostaInformacao"
                                }
                              }),
                              _c("br"),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2980384510
                    )
                  }),
                  _c("app-divider", { attrs: { label: "Anexos da mensagem" } }),
                  _c("app-anexo", {
                    attrs: {
                      id: "upload-informacao",
                      scope: "anexoInformacao",
                      files: _vm.anexos,
                      exibirDownload: false
                    },
                    on: {
                      uploadFile: _vm.uploadFile,
                      removeFile: _vm.removeFile,
                      downloadDocumentoCadastro: _vm.downloadDocumentoCadastro
                    }
                  }),
                  _c("app-buttons-cadastro", {
                    attrs: {
                      isUltimoPasso: true,
                      isPrimeiroPasso: true,
                      showButtonSalvar: false,
                      showButtonFinalizar: false,
                      showButtonEnviar: true
                    },
                    on: { enviar: _vm.enviar, cancelar: _vm.cancelar }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12d06bfd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12d06bfd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/ResponderInformacoes.vue
// module id = null
// module chunks = 